import { Component, OnInit } from '@angular/core';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CambioPropietarioService } from './cambio-propietario.service';
import { TipoIdentificacionEntry } from 'src/app/shared/entrys/tipo_identificacion.entry';
import { BasicasLoVService } from 'src/app/shared/services/basicas-lov.service';
import { EstablecimientoComercioService } from '../../../prestador/establecimiento-comercio/establecimiento-comercio.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CamaraComercioEntry } from 'src/app/shared/entrys/camara-comercio';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';
import { AlertsService } from 'src/app/shared/services/alerts.service';
import { AlertType } from 'src/app/shared/models/alert.model';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from 'src/app/shared/models/confirmar-respuesta.model';

@Component({
	selector: 'app-cambio-propietario',
	templateUrl: './cambio-propietario.component.html',
	styleUrls: ['./cambio-propietario.component.scss']
})
export class CambioPropietarioComponent implements OnInit {
	informacionEstablecimiento: any;
	informacionPrestador: any;
	formMatricula: FormGroup;
	paginaActual: number;
	adminSuper = RolesUsuario.AdministradorSuper;
	prestador = RolesUsuario.Prestador;
	// formPrestadors
	formPrestador: FormGroup;
	public isCollapsed = true;
	camaraComercio: string;
	// Selects
	tipoUsuario: Array<any> = [];

	constructor(private formBuilder: FormBuilder, private cambioPropietarioService: CambioPropietarioService,
		private establecimientoComercioService: EstablecimientoComercioService, private alertService: AlertsService,
		public authService: AuthService, private modalService: NgbModal) {
		this.createForm();
		this.informacionEstablecimiento = null;
		this.informacionPrestador = null;
	}

	ngOnInit() {
		this.establecimientoComercioService.getCamaras().subscribe(resultado => {
			if (resultado) {
				if (!this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
					this.formMatricula.get('codigo_camara').patchValue(this.authService.getCamaraUser());
				}
			}
		});
	}

	createForm() {
		this.formMatricula = this.formBuilder.group({
			matricula: [null, Validators.required],
			codigo_camara: [null],
		});

		this.formPrestador = this.formBuilder.group({
			digito_verificacion: [null, Validators.required],
			numero_identificacion: [null, Validators.required],
		});

	}
	buscarEstablecimiento() {
		this.cambioPropietarioService.get(this.formMatricula.value).subscribe(resultado => {
			if (resultado.result) {
				this.informacionEstablecimiento = resultado.data;
			}
		});
	}
	buscarPrestador() {
		this.cambioPropietarioService.getPrestador(this.formPrestador.value).subscribe(resultado => {
			if (resultado.result) {
				this.informacionPrestador = resultado.data;
			}
		});

	}

	cambiarPropietario() {
		const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
		const confirmarRespuesta = {} as ConfirmarRespuestaModel;
		confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
		confirmarRespuesta.message = `¿Está seguro de realizar el cambio de propietario?`;
		modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
		modalRef.result.then(() => {
			this.cambioPropietarioService.changePropietario({
				codigo_camara_establecimiento: this.informacionEstablecimiento.codigo_camara,
				establecimiento_id: this.informacionEstablecimiento.establecimiento_id,
				razon_social_establecimiento: this.informacionEstablecimiento.razon_social_establecimiento,
				razon_social_prestador_establecimiento: this.informacionEstablecimiento.razon_social_prestador,
				codigo_camara_prestador: this.informacionPrestador.codigo_camara,
				prestador_id: this.informacionPrestador.prestador_id,
				razon_social_prestador: this.informacionPrestador.razon_social,
				matricula: this.formMatricula.value.matricula
			}).subscribe(resultado => {
				if (resultado.result) {
					this.informacionEstablecimiento = null;
					this.informacionPrestador = null;
					this.formMatricula.reset();
					this.formPrestador.reset();
					this.alertService.alert(resultado.control.alert_type as AlertType, 'Cambio de propietario exitoso.',
						`/admin/cambio-propietario`,
						resultado.control.code.toString(), true);
				}
			});
		});
	}
}

